import {
    ADD_NODE_LOGIC_EFFECT,
    REMOVE_NODE_LOGIC_EFFECT,
    UPDATE_NODE_LOGIC_EFFECT,
    REPLICATE_FORM_NODE_LOGIC_EFFECT,
    REPLICATE_ADDITIONAL_FORM_NODE_LOGIC_EFFECT,
    ADD_MULTIPLE_NODE_LOGIC_EFFECT,
} from '../constants/epicTypes';

// Effects
export const replicateFormNodeLogicEffect = (meta) => ({
    type: REPLICATE_FORM_NODE_LOGIC_EFFECT,
    meta,
});

export const replicateAdditionalFormNodeLogicEffect = (meta) => ({
    type: REPLICATE_ADDITIONAL_FORM_NODE_LOGIC_EFFECT,
    meta,
});

export const addNodeLogicEffect = (meta) => ({
    type: ADD_NODE_LOGIC_EFFECT,
    meta,
});

export const removeFormLogicEffect = (meta) => ({
    type: REMOVE_NODE_LOGIC_EFFECT,
    meta,
});

export const updateFormLogicEffect = (meta) => ({
    type: UPDATE_NODE_LOGIC_EFFECT,
    meta,
});

export const addMultipleNodeLogicEffect = (meta) => ({
    type: ADD_MULTIPLE_NODE_LOGIC_EFFECT,
    meta,
});
